import { render, staticRenderFns } from "./BBW_SettingsWindow.vue?vue&type=template&id=085d7273&scoped=true"
import script from "./BBW_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./BBW_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d7273",
  null
  
)

export default component.exports